import config from '../config'

import {
	PATIENT_GROUP,
	FUNDER_GROUP,
	ADMINISTRATOR_GROUP,
	AUTOMANAGEMENTFUNDER_GROUP,
	MEDIC_GROUP,
	PREGNANCYPLANNER_GROUP,
	BILLING_GROUP,
	PATIENT,
	FUNDER,
	FUNDERMEDIC,
	FUNDERADMINISTRATIVE,
	ADMINISTRATOR,
	AUTOMANAGEMENTFUNDER,
	MEDIC,
	PREGNANCYPLANNER,
	BILLING
} from './roles'

import {
	USERS,
	PREGNANCYPLANNER_ADMIN_PERMIT,
	DUTIES,
	BILLING_PERMIT,
	LOGS,
	ROLES
} from './permits'
import {
	Laptop,
	HappyFace,
	Home,
	Medical,
	Mail,
	ClipBoard,
	Group,
	Cash,
	Bill,
	UserDocument,
	Info,
	Bars,
	UserAvatar,
	FilePlus
} from '../assets/icons'

export const ACCES_BY_ROLE_GROUP = {
	[PATIENT_GROUP]: [
		{
			id: 'home',
			label: 'Inicio',
			icon: Home,
			path: '/inicio',
			roles: [PATIENT],
			mobileTab: 'bottom'
		},
		{
			id: 'guard',
			label: 'Ingresar a la guardia',
			icon: Medical,
			path: '/inicio/guardia',
			roles: [PATIENT],
			mobileLabel: 'Turnos',
			mobileTab: 'more'
		},
		{
			id: 'prescriptions',
			label: 'Ordenes',
			icon: FilePlus,
			path: '/inicio/ordenes',
			roles: [PATIENT],
			mobileTab: 'more'
		},
		{
			id: 'turnos',
			label: 'Turnos',
			icon: Laptop,
			mobileLabel: 'Turnos',
			mobileIcon: Medical,
			path: '/inicio/turnos',
			roles: [PATIENT],
			mobileTab: 'bottom'
		},
		{
			id: 'lab',
			label: 'Resultados de laboratorio',
			icon: ClipBoard,
			path: '/inicio/laboratorios',
			roles: [PATIENT],
			mobileTab: 'more'
		},
		{
			id: 'contact',
			label: 'Formulario de contacto',
			icon: Mail,
			path: '/inicio/formulario-de-contacto',
			roles: [PATIENT],
			mobileTab: 'more'
		}
	],

	[MEDIC_GROUP]: [
		{ id: 'home', label: 'Inicio', icon: Home, path: '/inicio', roles: [MEDIC] },

		{
			id: 'Videoconsulta',
			label: 'Videoconsulta',
			icon: HappyFace,
			path: '/inicio/Videoconsulta',
			roles: [MEDIC]
		}
	],
	[FUNDER_GROUP]: [
		{
			id: 'home',
			label: 'Inicio',
			icon: Home,
			path: '/inicio',
			roles: [FUNDER, FUNDERMEDIC, FUNDERADMINISTRATIVE]
		},
		{
			id: 'Pacientes Internados',
			label: 'Pacientes Internados',
			icon: Medical,
			path: '/inicio/pacientes-internados',
			roles: [FUNDER, FUNDERMEDIC]
		},
		{
			id: 'Aranceles',
			label: 'Aranceles',
			icon: Cash,
			path: '/inicio/aranceles',
			permit: DUTIES,
			roles: [FUNDER, FUNDERADMINISTRATIVE]
		},
		{
			id: 'Facturación',
			label: 'Facturación',
			icon: Bill,
			path: '/inicio/facturacion',
			permit: BILLING_PERMIT,
			roles: [FUNDERADMINISTRATIVE]
		}
	],
	[ADMINISTRATOR_GROUP]: [
		{ id: 'home', label: 'Inicio', icon: Home, path: '/inicio', roles: [ADMINISTRATOR] },

		{
			id: 'Usuarios',
			label: 'Usuarios',
			icon: Group,
			path: '/inicio/usuarios',
			roles: [ADMINISTRATOR]
		},

		{
			id: 'Roles',
			label: 'Roles',
			icon: UserDocument,
			path: '/inicio/roles',
			roles: [ADMINISTRATOR]
		},

		{
			id: 'Reporte de Accesos',
			label: 'Reporte de Accesos',
			icon: Info,
			path: '/inicio/logs',
			roles: [ADMINISTRATOR]
		}
	],
	[AUTOMANAGEMENTFUNDER_GROUP]: [
		{ id: 'home', label: 'Inicio', icon: Home, path: '/inicio', roles: [AUTOMANAGEMENTFUNDER] },

		{
			id: 'Usuarios',
			label: 'Usuarios',
			icon: Group,
			permit: USERS,
			path: '/inicio/usuarios',
			roles: [AUTOMANAGEMENTFUNDER],
			isPregnant: true
		}
	],
	[PREGNANCYPLANNER_GROUP]: [
		{ id: 'home', label: 'Inicio', icon: Home, path: '/inicio', roles: [PREGNANCYPLANNER] },
		{
			id: 'Usuarios',
			label: 'Usuarios',
			icon: Group,
			path: '/inicio/usuarios',
			roles: [PREGNANCYPLANNER]
		},
		{
			isPregnancyAdmin: true,
			isExternalLink: true,

			id: 'Pregnancy Planner',
			label: 'Pregnancy Planner',
			icon: Group,
			path: `${config.endpoints.PREGNANCYPLANNER_URL}/login`,
			permit: PREGNANCYPLANNER_ADMIN_PERMIT,
			roles: [PREGNANCYPLANNER]
		}
	],
	[BILLING_GROUP]: [
		{ id: 'home', label: 'Inicio', icon: Home, path: '/inicio', roles: [BILLING] },
		{
			id: 'Facturación',
			label: 'Facturación',
			icon: Bill,
			path: '/inicio/facturacion',
			roles: [BILLING]
		}
	]
}

export const DIRECT_ACCES_BY_ROLE_GROUP = {
	[PATIENT_GROUP]: [
		{
			id: 'guard',
			label: 'Ingresar a la guardia',
			icon: Medical,
			mobileLabel: 'Ir a la guardia',

			path: '/inicio/guardia',
			roles: [PATIENT]
		},
		{
			id: 'turnos',
			label: 'Turnos',
			icon: Laptop,
			mobileLabel: 'Turnos',
			mobileIcon: Medical,
			hideOnMobileDirectAccess: true,
			path: '/inicio/turnos',
			roles: [PATIENT]
		},
		{
			id: 'lab',
			label: 'Resultados de laboratorio',
			icon: ClipBoard,
			path: '/inicio/laboratorios',
			roles: [PATIENT]
		},
		{
			id: 'contact',
			label: 'Formulario de contacto',
			icon: Mail,
			path: '/inicio/formulario-de-contacto',
			roles: [PATIENT]
		}
	],

	[MEDIC_GROUP]: [
		{
			textHeadr: 'Desde acá podrás ingresar a videoconsulta',
			id: 'Videoconsulta',
			label: 'Videoconsulta',
			icon: HappyFace,
			path: '/inicio/Videoconsulta',
			roles: [MEDIC]
		}
	],
	[FUNDER_GROUP]: [
		{
			id: 'Pacientes Internados',
			label: 'Pacientes Internados',
			icon: Medical,
			path: '/inicio/pacientes-internados',
			roles: [FUNDER, FUNDERMEDIC]
		},
		{
			id: 'Aranceles',
			label: 'Aranceles',
			icon: Cash,
			path: '/inicio/aranceles',
			permit: DUTIES,
			roles: [FUNDER, FUNDERADMINISTRATIVE]
		},
		{
			id: 'Facturación',
			label: 'Facturación',
			icon: Bill,
			path: '/inicio/facturacion',
			permit: BILLING_PERMIT,
			roles: [FUNDERADMINISTRATIVE]
		}
	],
	[ADMINISTRATOR_GROUP]: [
		{
			id: 'Usuarios',
			label: 'Usuarios',
			icon: Group,
			path: '/inicio/usuarios',
			roles: [ADMINISTRATOR]
		},

		{
			id: 'Roles',
			label: 'Roles',
			icon: UserDocument,
			path: '/inicio/roles',
			roles: [ADMINISTRATOR]
		},

		{
			id: 'Reporte de Accesos',
			label: 'Reporte de Accesos',
			icon: Info,
			path: '/inicio/logs',
			roles: [ADMINISTRATOR]
		}
	],
	[AUTOMANAGEMENTFUNDER_GROUP]: [
		{
			id: 'Usuarios',
			label: 'Usuarios',
			icon: Group,
			permit: USERS,
			path: '/inicio/usuarios',
			roles: [AUTOMANAGEMENTFUNDER],
			isPregnant: true
		}
	],
	[PREGNANCYPLANNER_GROUP]: [
		{
			id: 'Usuarios',
			label: 'Usuarios',
			icon: Group,
			path: '/inicio/usuarios',
			roles: [PREGNANCYPLANNER]
		},
		{
			isPregnancyAdmin: true,
			isExternalLink: true,

			id: 'Pregnancy Planner',
			label: 'Pregnancy Planner',
			icon: Group,
			path: `${config.endpoints.PREGNANCYPLANNER_URL}/login`,
			permit: PREGNANCYPLANNER_ADMIN_PERMIT,

			roles: [PREGNANCYPLANNER]
		}
	],
	[BILLING_GROUP]: [
		{
			id: 'Facturación',
			label: 'Facturación',
			icon: Bill,
			path: '/inicio/facturacion',
			roles: [BILLING]
		}
	]
}

export const ROUTE_METADATA = {
	'/inicio': {
		[PATIENT_GROUP]: {
			title: 'Accesos directos'
		},
		[ADMINISTRATOR_GROUP]: {
			title: 'Administrador',
			message: 'Desde acá podrás gestionar Aranceles y Pacientes Internados.'
		},
		[MEDIC_GROUP]: {
			title: 'Accesos directos',

			message: 'Desde acá podrás ingresar a videoconsulta'
		},
		[FUNDER_GROUP]: {
			message: 'Desde acá podrás gestionar Aranceles y Pacientes Internados.'
		},
		[BILLING_GROUP]: {
			title: 'Facturación',
			message: 'Desde acá podrás gestionar la facturación',
			infoTitle: 'Información importante',
			infoMessage: 'Recordamos que, a partir del 1° julio, las Facturas y comprobantes de atención de internación, procedimientos quirúrgicos y Guardia de Clínica Santa Isabel serán emitidos en formato digital.'
		}
	}
}

export const MOBILE_TABS = {
	[PATIENT_GROUP]: [
		{ id: 'home', label: 'Inicio', icon: Home, path: '/inicio', roles: [PATIENT] },
		{
			id: 'turnos',
			label: 'Turnos',
			icon: Laptop,
			path: '/inicio/programar-turnos',
			roles: [PATIENT]
		},
		{
			id: 'mas',
			label: 'Más',
			icon: Bars,
			path: '/inicio/ver-mas',
			subRoutes: [
				{
					id: 'data',
					label: 'Mis datos',
					icon: UserAvatar,
					path: '/inicio/mis-datos',
					roles: [PATIENT]
				},

				{
					id: 'prescriptions',
					label: 'Ordenes',
					icon: FilePlus,
					path: '/inicio/ordenes',
					roles: [PATIENT],
				},
				{
					id: 'prescriptions',
					label: 'Ordenes',
					icon: FilePlus,
					path: '/inicio/ordenes',
					roles: [PATIENT]
				},
				{
					id: 'guard',
					label: 'Ingresar a la guardia',
					icon: Medical,
					path: '/inicio/guardia',
					roles: [PATIENT]
				},
				{
					id: 'lab',
					label: 'Resultados de laboratorio',
					icon: ClipBoard,
					path: '/inicio/laboratorios',
					roles: [PATIENT]
				},
				{
					id: 'contact',
					label: 'Formulario de contacto',
					icon: Mail,
					path: '/inicio/formulario-de-contacto',
					roles: [PATIENT]
				}
			]
		}
	],
	[MEDIC_GROUP]: [
		{
			id: 'Videoconsulta',
			label: 'Videoconsulta',
			icon: HappyFace,
			path: '/inicio/Videoconsulta',
			roles: [MEDIC]
		},
		{
			id: 'mas',
			label: 'Más',
			icon: Bars,
			path: '/inicio/ver-mas',
			subRoutes: [
				{
					id: 'data',
					label: 'Mis datos',
					icon: UserAvatar,
					path: '/inicio/mis-datos',
					roles: [BILLING]
				},

				{
					id: 'contact',
					label: 'Formulario de contacto',
					icon: Mail,
					path: '/inicio/formulario-de-contacto',
					roles: [BILLING]
				}
			]
		}
	],
	[FUNDER_GROUP]: [
		{
			id: 'Aranceles',
			label: 'Aranceles',
			icon: Cash,
			path: '/inicio/aranceles',
			permit: DUTIES,
			roles: [FUNDER, FUNDERADMINISTRATIVE]
		},
		{
			id: 'Pacientes Internados',
			label: 'Pacientes Internados',
			icon: Medical,
			path: '/inicio/pacientes-internados',
			roles: [FUNDER, FUNDERMEDIC]
		},
		{
			id: 'Facturación',
			label: 'Facturación',
			icon: Bill,
			path: '/inicio/facturacion',
			permit: BILLING_PERMIT,
			roles: [BILLING]
		},
		{
			id: 'mas',
			label: 'Más',
			icon: Bars,
			path: '/inicio/ver-mas',
			subRoutes: [
				{
					id: 'data',
					label: 'Mis datos',
					icon: UserAvatar,
					path: '/inicio/mis-datos',
					roles: [BILLING]
				},

				{
					id: 'contact',
					label: 'Formulario de contacto',
					icon: Mail,
					path: '/inicio/formulario-de-contacto',
					roles: [BILLING]
				}
			]
		}
	],
	[ADMINISTRATOR_GROUP]: [
		{
			id: 'Administrador',
			label: 'Administrador',
			icon: HappyFace,
			path: '/inicio',
			roles: [ADMINISTRATOR],
			subList: [
				{
					id: 'Usuarios',
					label: 'Usuarios',
					icon: Group,
					path: '/inicio/usuarios',
					roles: [ADMINISTRATOR]
				},

				{
					id: 'Roles',
					label: 'Roles',
					icon: UserDocument,
					path: '/inicio/roles',
					roles: [ADMINISTRATOR]
				},

				{
					id: 'Reporte de Accesos',
					label: 'Reporte de Accesos',
					icon: Info,
					path: '/inicio/logs',
					roles: [ADMINISTRATOR]
				}
			]
		},
		{
			id: 'mas',
			label: 'Más',
			icon: Bars,
			path: '/inicio/ver-mas',
			subRoutes: [
				{
					id: 'data',
					label: 'Mis datos',
					icon: UserAvatar,
					path: '/inicio/mis-datos',
					roles: [BILLING]
				},
				{
					id: 'contact',
					label: 'Formulario de contacto',
					icon: Mail,
					path: '/inicio/formulario-de-contacto',
					roles: [BILLING]
				}
			]
		}
	],
	[AUTOMANAGEMENTFUNDER_GROUP]: [
		{
			id: 'Usuarios',
			label: 'Usuarios',
			icon: Group,
			permit: USERS,
			path: '/inicio/usuarios',
			roles: [AUTOMANAGEMENTFUNDER],
			isPregnant: true
		},
		{
			id: 'mas',
			label: 'Más',
			icon: Bars,
			path: '/inicio/ver-mas',
			roles: [AUTOMANAGEMENTFUNDER],
			subRoutes: [
				{
					id: 'data',
					label: 'Mis datos',
					icon: UserAvatar,
					path: '/inicio/mis-datos',
					roles: [AUTOMANAGEMENTFUNDER]
				}
			]
		}
	],
	[PREGNANCYPLANNER_GROUP]: [
		{
			id: 'Usuarios',
			label: 'Usuarios',
			icon: Group,
			path: '/inicio/usuarios',
			roles: [PREGNANCYPLANNER]
		},
		{
			isPregnancyAdmin: true,
			isExternalLink: true,

			id: 'Pregnancy Planner',
			label: 'Pregnancy Planner',
			icon: Group,
			path: `${config.endpoints.PREGNANCYPLANNER_URL}/login`,
			permit: PREGNANCYPLANNER_ADMIN_PERMIT,
			roles: [PREGNANCYPLANNER]
		},
		{
			id: 'mas',
			label: 'Más',
			icon: Bars,
			path: '/inicio/ver-mas',
			roles: [PREGNANCYPLANNER],
			subRoutes: [
				{
					id: 'data',
					label: 'Mis datos',
					icon: UserAvatar,
					path: '/inicio/mis-datos',
					roles: [PREGNANCYPLANNER]
				}
			]
		}
	],
	[BILLING_GROUP]: [
		{
			id: 'Facturación',
			label: 'Facturación',
			icon: Bill,
			path: '/inicio/facturacion',
			roles: [BILLING]
		},
		{
			id: 'mas',
			label: 'Más',
			icon: Bars,
			path: '/inicio/ver-mas',
			subRoutes: [
				{
					id: 'data',
					label: 'Mis datos',
					icon: UserAvatar,
					path: '/inicio/mis-datos',
					roles: [BILLING]
				},

				{
					id: 'contact',
					label: 'Formulario de contacto',
					icon: Mail,
					path: '/inicio/formulario-de-contacto',
					roles: [BILLING]
				}
			]
		}
	]
}
